import React, { useState, useEffect } from 'react'
import CartExpiration from './cart-expiration'
import SharedSummary from './gpp-shared-summary'
import {
  getDateForTest,
  timeDifference
} from '../../shared/components/gpp-test-timer'
import { clearGroupCart, resetClearedCartFlag } from '../../services/api'

const GppSharedTimer = ({ expiresAt }) => {
  const [expired, setExpired] = useState(
    timeDifference(TEST_TIMER || expiresAt) <= 0
  )

  const groupTripInfo = sessionStorage.getItem('group-trip-info')
    ? JSON.parse(sessionStorage.getItem('group-trip-info'))
    : null

  let timer
  const startTimer = timeDifference => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      setExpired(true)
      emptyCart()
    }, timeDifference)
  }

  const TEST_TIMER = getDateForTest()

  const cartExpirationClick = async () => {
    try {
      const result = await resetClearedCartFlag(groupTripInfo.id)
      sessionStorage.setItem('group-trip-info', JSON.stringify(result))
    } catch (e) {
      console.log(e)
    }
    location.pathname = '/group-tickets/group-cart'
  }

  useEffect(() => {
    !TEST_TIMER && startTimer(timeDifference(TEST_TIMER || expiresAt))
  }, [])

  const emptyCart = async () => {
    clearTimeout(timer)
    if (groupTripInfo?.cart?.id) {
      try {
        const deleteItems = await clearGroupCart(groupTripInfo.id, false, true)
        sessionStorage.setItem('group-trip-info', JSON.stringify(deleteItems))
      } catch (e) {
        console.log(e)
      }
    } else {
      return
    }
  }

  return (
    <>
      <div>
        <CartExpiration
          expiresAt={TEST_TIMER || expiresAt}
          fromGpp={true}
          onClick={cartExpirationClick}
        />
      </div>
      {!expired && (
        <div className="gpp-sidebar-container gpp-complete-purchase">
          <SharedSummary groupTripInfo={groupTripInfo} />
        </div>
      )}
    </>
  )
}

export default GppSharedTimer
